import api from './api';

const balanceContadorService = {
  obtener: async (anio, mes) => {
    const { data } = await api.get('/balance-contador', { params: { anio, mes } });
    return data.data;
  },
};

export default balanceContadorService;